<template>
    <max-z-index :show="isShow">
      <masks
        v-if="mask"
        :mshow="isShow"
        :mopacity = "mOpacity"
        @maskTap="maskTap"
        >
      </masks>
      <div class="beast_slider" :style="{'z-index': zIndex, height: height}" :class="[mfrom , { beast_slide_from_reset : isShow }, slidecls]" >
        <slot></slot>
      </div>
    </max-z-index>
</template>

<script>
import Masks from '@/components/mask/index.vue'
import MaxZIndex from '@/components/max-z-index/index.vue'

export default {
  components:{
    Masks,
    MaxZIndex
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: 'left'
    },
    zIndex: {
      default: 1001
    },
    height: {
      type: String,
      default: 'auto'
    },
    mask: {
      // type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    },
    slidecls: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  watch: {
    'show': function (val) {
      this.showChange()
    }
  },
  created(){
    this.showChange()
    // console.log(MaxZIndex.getZIndex());
  },
  computed:{
    mOpacity: function(){
      return parseFloat(this.maskOpacity)
    },
    mfrom: function(){
      return `beast_slide_from_${this.from}`
    }
  },
  methods: {
    showChange() {
      let _show = this.show
      // this.mfrom =  _show ? `` : ''
      this.isShow = _show
    },
    // maskHide(){
    //   (this.mOpacity != 0) && this.mask && this.$emit('onHide')
    // },
    maskTap () {
      this.$emit('maskTap')
    }
  }
}
</script>

<style lang="stylus">
  .beast_slide-container
    position relative
  .beast_slider
    position fixed
    overflow-x hidden
    background #fff
    width 100%
    // z-index 1001
    transition transform .3s ease-in
    &::-webkit-scrollbar
      display none
  .beast_slide_from_
    &left
      transform translateX(-100%)
      top 0
      left 0
    &right
      transform translateX(100%)
      top 0
      right 0
    &top
      transform translateY(-100%)
      top 0
      left 0
    &bottom
      transform translateY(100%)
      bottom 0
      left 0
  .beast_slide_from_reset
    transform translate(0)!important

</style>



// WEBPACK FOOTER //
// index.vue?9f01e1f6